export class MartianChessFailure {
    static MUST_CHOOSE_PIECE_FROM_YOUR_TERRITORY = () => $localize `You must pick a piece from your side of the board in order to move it.`;
    static CANNOT_CAPTURE_YOUR_OWN_PIECE_NOR_PROMOTE_IT = () => $localize `This is not a valid promotion nor a valid capture.`;
    static CANNOT_UNDO_LAST_MOVE = () => $localize `You cannot perform a move that is the reverse of the previous one.`;
}
